import { render, staticRenderFns } from "./TruckAssignment.vue?vue&type=template&id=79548a36&scoped=true&"
import script from "./TruckAssignment.vue?vue&type=script&lang=js&"
export * from "./TruckAssignment.vue?vue&type=script&lang=js&"
import style0 from "./TruckAssignment.vue?vue&type=style&index=0&id=79548a36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79548a36",
  null
  
)

export default component.exports